module.exports = __webpack_public_path__ + "img/Medieval_Sword_Viking.b43e7821.png";